import * as React from 'react'

import EnhancedLazyLoad from '../../components/enhancedLazyLoad'
import ImagePlaceholder from '../../components/imagePlaceholder'

import * as styles from './thumbnailsSidebar.module.css'

interface IThumbnail {
  imgSrc?: string
  link: string
  title?: string
}

interface IProps {
  title?: string
  thumbnails?: IThumbnail[]
}

const ThumbnailsSidebar = ({ title, thumbnails }: IProps) => {
  return (
    <aside className={styles.root}>
      {title && (
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
        </header>
      )}
      <ul className={styles.thumbnailList}>
        {thumbnails &&
          thumbnails.map(thumbnail => (
            <li className={styles.thumbnail} key={thumbnail.link}>
              <a href={thumbnail.link}>
                <EnhancedLazyLoad
                  placeholder={
                    <ImagePlaceholder
                      ratio={0}
                      className={styles.thumbnailImg}
                    />
                  }
                >
                  <img
                    src={thumbnail.imgSrc}
                    className={styles.thumbnailImg}
                    alt={thumbnail.title}
                  />
                </EnhancedLazyLoad>
              </a>
              {thumbnail.title && (
                <h3 className={styles.thumbnailTitle}>
                  <a href={thumbnail.link} className={styles.thumbnailLink}>
                    {thumbnail.title}
                  </a>
                </h3>
              )}
            </li>
          ))}
      </ul>
    </aside>
  )
}

export default ThumbnailsSidebar
